export const iconos_arrow = {
    iconArrow: require("../images/iconosinicio/flecha.png"),
    };